import { Dispatch, FC, SetStateAction } from 'react';
import { ArrayField, Multistep, useFormState } from 'informed';
import { IYupSchema, STEPS, STEPS_ICONS, STEPS_LABELS } from '../../consts';
import InformedField from '../InformedField';
import Subtitle from '../Subtitle';
import Navigation from '../Navigation';
import { Button, Dropdown } from '@components';
import { TrashIcon } from '@assets/svg';
import { DataItem } from '@common/interfaces';
import css from './styles.module.scss';

interface IUsersStep {
  setYupSchema: Dispatch<SetStateAction<IYupSchema>>;
  usersOptions: DataItem[];
}

const FocalPointsError = () => {
  const { errors, touched } = useFormState();
  const error = (errors?.users as any)?.focal_points;
  const isTouched = (touched?.users as any)?.focal_points;
  if (!error || !isTouched) return null;
  return <div className={css.error}>{error as any}</div>;
};

const UsersStep: FC<IUsersStep> = ({ setYupSchema, usersOptions }) => {
  return (
    <Multistep.Step step={STEPS.USERS}>
      <Subtitle text={STEPS_LABELS.USERS} icon={STEPS_ICONS.USERS} />
      <InformedField
        label='Focal points'
        description='Email addresses allowed to access the Digital Office and perform actions'
      >
        <ArrayField name='focal_points'>
          {({ add }) => (
            <div>
              <ArrayField.Items>
                {({ remove, name, index }) => {
                  return (
                    <div key={name} className={css.row}>
                      <Dropdown
                        isSearchable
                        placeholder='Select email address'
                        name={name}
                        options={usersOptions}
                        variant='dark'
                        skipError
                      />
                      {index !== 0 ? <Button iconL={<TrashIcon />} variant='icon' onClick={remove} /> : null}
                    </div>
                  );
                }}
              </ArrayField.Items>
              <FocalPointsError />
              <Button type='button' variant='text' text='Add another focal point +' onClick={() => add()} />
            </div>
          )}
        </ArrayField>
      </InformedField>
      <Navigation setYupSchema={setYupSchema} />
    </Multistep.Step>
  );
};

export default UsersStep;
